"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiagnosticsDataService = void 0;
const api_1 = require("../api");
const configurationError = "Contact Decodable support to ensure your data plane is properly configured to support diagnostics.";
class DiagnosticsDataService {
    constructor({ client }) {
        this.apiVersion = api_1.apiVersion;
        this.client = client;
    }
    getDiagnostics(params) {
        return __awaiter(this, void 0, void 0, function* () {
            let response;
            try {
                response = yield this.client.fetch(`/${this.apiVersion}/diagnostics`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${params.token}`,
                        "Content-Type": "application/json",
                        Accept: "application/x-tar",
                    },
                    body: params.data_plane_request,
                });
            }
            catch (ex) {
                // If the fetch fails, it's likely the data plane API is not upgraded.
                // It could also be misconfigured. Suggest the user contact support to
                // verify their configuration.
                throw new Error(configurationError, ex);
            }
            // Legacy data plane API may reject this request. Use the configuration
            // error in these cases so we can walk them through the upgrade.
            // This is a bit imprecise but glosses over a breaking API change.
            if (!response.ok) {
                throw new Error(configurationError);
            }
            return response.blob();
        });
    }
}
exports.DiagnosticsDataService = DiagnosticsDataService;
